{
  "attached": {
    "acceptedOnly": "Nur angenommene Daten",
    "anyKind": "Beliebig",
    "chosen": "Gewählte Labels und Begriffe",
    "clear": "Filter zurücksetzen",
    "facets": "Labels und Begriffe",
    "facetsPlaceholder": "Label oder Begriff wählen",
    "filters": "Filter",
    "inState": "{{kind}}, {{state}}",
    "kind": "Angehängte Daten",
    "label": "Label",
    "noFacets": "Kein Label und kein Begriff mit diesem Namen.",
    "nothing": "Nichts angehängt",
    "remove": "{{name}} entfernen",
    "term": "Begriff"
  },
  "corpora": {
    "all": "Alle Korpora werden durchsucht. Entfernen Sie einen Haken, um ein Korpus auszulassen.",
    "field": "Text oder Schlüssel suchen",
    "legend": "Korpora",
    "noneTicked": "Wählen Sie mindestens ein Korpus zum Suchen."
  },
  "filters": {
    "segment": "Suchen in",
    "statements": "Angehängte Aussagen",
    "wholeDocument": "Ganzes Dokument"
  },
  "fuzzyRefused": "Unscharfe Wörter wie wort~1 brauchen die volle Suche. Diese Installation nutzt die leichte Suche. Entfernen Sie das ~ und suchen Sie noch einmal.",
  "library": {
    "artifactTypes": "Artefakttypen",
    "everything": "Alles",
    "filter": "Zeigen",
    "kinds": "Arten"
  },
  "noHits": "Nichts gefunden.",
  "searching": "Suche läuft…",
  "showMore": "Mehr zeigen",
  "syntax": {
    "address": "Mit @Version oder #Segment nach einem Schlüssel öffnen Sie diese Version oder dieses Segment.",
    "fuzzy": "wort~1 oder wort~2 findet auch Wörter, in denen ein oder zwei Buchstaben anders sind.",
    "fuzzyLightMode": "Unscharfe Wörter brauchen die volle Suche. Diese Installation nutzt die leichte Suche, daher gehen sie hier nicht.",
    "key": "Ein Schlüssel wie in der Liste, vollständig oder kurz, findet zuerst sein Dokument.",
    "or": "OR zwischen Wörtern findet eines davon: Brief OR Urkunde.",
    "phrase": "\"…\" findet genau diese Wortfolge innerhalb eines Segments.",
    "title": "So suchen Sie",
    "words": "Jedes Wort muss vorkommen. Sie können AND dazwischen schreiben."
  }
}
